import { moeTrackEvent } from "../utils/moengage";

let moengageInstance = null;

export const initializeMoEngage = () => {
    if (!moengageInstance) {
        const moengageConfig = {
            app_id: "GZITWR8Y5OXIQDPXCVGPETLS_DEBUG", // Replace with your MoEngage App ID
            debug_logs: true,
        };

        window.Moengage.initialize(moengageConfig);
        moengageInstance = window.Moengage;
    }
    return moengageInstance;
};


// initializeMoEngage()

export const fireEvent = (eventName, eventDetails) => {
    return moeTrackEvent(eventName, eventDetails);
}